import React, { useRef, useState, useCallback } from 'react';

const REVEAL_LEFT  = 168; // swipe left → actions (Anruf, Aufgabe, Notiz)
const REVEAL_RIGHT = 80;  // swipe right → WhatsApp / schnelle Aktion

/** Horizontales Swipe: Links → Aktionen (Anruf/Aufgabe/Notiz), Rechts → WhatsApp */
export default function MobileContactSwipeRow({
  children,
  onCall,
  onTask,
  onNote,
  onWhatsApp,
  hasTel,
  hasTask,
  hasNote,
  hasWhatsApp,
}) {
  const [dx, setDx] = useState(0);
  const [dragging, setDragging] = useState(false);
  const start = useRef({ x: 0, y: 0, active: false, locked: false });

  const clamp = useCallback((v) => Math.max(-REVEAL_LEFT, Math.min(REVEAL_RIGHT, v)), []);

  const onTouchStart = (e) => {
    const t = e.touches[0];
    start.current = { x: t.clientX, y: t.clientY, active: true, locked: false };
  };

  const onTouchMove = (e) => {
    if (!start.current.active) return;
    const t = e.touches[0];
    const mx = t.clientX - start.current.x;
    const my = t.clientY - start.current.y;
    if (!start.current.locked) {
      if (Math.abs(mx) > Math.abs(my) && Math.abs(mx) > 10) start.current.locked = 'h';
      else if (Math.abs(my) > Math.abs(mx) && Math.abs(my) > 10) start.current.active = false;
    }
    if (start.current.locked === 'h') {
      e.preventDefault();
      setDragging(true);
      setDx(clamp(mx));
    }
  };

  const onTouchEnd = () => {
    start.current.active = false;
    setDragging(false);
    setDx(d => {
      if (d < -REVEAL_LEFT / 2) return -REVEAL_LEFT;  // snap open left
      if (d > REVEAL_RIGHT / 2) return REVEAL_RIGHT;   // snap open right
      return 0;
    });
  };

  const close = () => setDx(0);

  return (
    <div style={{ position: 'relative', overflow: 'hidden', touchAction: 'pan-y' }}>

      {/* Left actions (revealed when swiping left) */}
      <div style={{
        position: 'absolute', right: 0, top: 0, bottom: 0, width: REVEAL_LEFT,
        display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end',
        pointerEvents: dx < -8 ? 'auto' : 'none',
      }}>
        <div style={{ display: 'flex', gap: 0, height: '100%' }}>
          {hasTel && (
            <button type="button" onClick={() => { close(); onCall?.(); }} className="crm-pressable" style={{ width: 56, border: 'none', background: 'rgba(22,163,74,0.15)', color: '#15803d', fontSize: 11, fontWeight: 700, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, cursor: 'pointer' }}>
              <span style={{ fontSize: 18 }}>📞</span>Anruf
            </button>
          )}
          {hasTask && (
            <button type="button" onClick={() => { close(); onTask?.(); }} className="crm-pressable" style={{ width: 56, border: 'none', background: 'rgba(143,124,201,0.15)', color: '#6d28d9', fontSize: 11, fontWeight: 700, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, cursor: 'pointer' }}>
              <span style={{ fontSize: 16 }}>✓</span>Aufgabe
            </button>
          )}
          {hasNote && (
            <button type="button" onClick={() => { close(); onNote?.(); }} className="crm-pressable" style={{ width: 56, border: 'none', background: 'rgba(202,138,4,0.18)', color: '#a16207', fontSize: 11, fontWeight: 700, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, cursor: 'pointer' }}>
              <span style={{ fontSize: 16 }}>📝</span>Notiz
            </button>
          )}
        </div>
      </div>

      {/* Right action (revealed when swiping right → WhatsApp) */}
      {hasWhatsApp && (
        <div style={{
          position: 'absolute', left: 0, top: 0, bottom: 0, width: REVEAL_RIGHT,
          display: 'flex', alignItems: 'stretch',
          pointerEvents: dx > 8 ? 'auto' : 'none',
        }}>
          <button type="button" onClick={() => { close(); onWhatsApp?.(); }} className="crm-pressable"
            style={{ width: REVEAL_RIGHT, border: 'none', background: 'rgba(37,211,102,0.18)', color: '#16a34a', fontSize: 11, fontWeight: 700, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, cursor: 'pointer' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" strokeLinecap="round" strokeLinejoin="round"/></svg>
            WA
          </button>
        </div>
      )}

      <div
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onTouchCancel={onTouchEnd}
        style={{
          transform: `translateX(${dx}px)`,
          transition: dragging ? 'none' : 'transform 0.18s ease-out',
          background: 'inherit',
        }}
      >
        {children}
      </div>
    </div>
  );
}
